import { string, object, number, date, array } from "yup";

import addressSchema from "../../utils/common-schemas/Address-schema";

const email = string()
  .email()
  .required("L'email est obligatoire");

const parentSchema = object().shape({
  nom: string().required("Le nom est obligatoire"),
  prenom: string().required("Le prenom est obligatoire"),
  email: email,
  adresseDto: addressSchema,
  dataNaissance: date(),
  sexe: string(),
  situation: string(),
  numeroTel: number()
});

const tierSchema = object().shape({
  nom: string(),
  prenom: string(),
  numeroTel: number(),
  lienDeParente: string()
});

const kidSchema = object().shape({
  photo: string().required(),
  nom: string().required("Le nom est obligatoire"),
  prenom: string().required("Le prénom est obligatoire"),
  dateNaissance: date().required("La date de naissance est obligatoire"),
  dateAdmission: date().required("La date d'admission est obligatoire"),
  adresseDto: addressSchema,
  poid: number(),
  taille: number(),
  parents: array().of(parentSchema),
  tierceAutorisesDto: array().of(tierSchema)
});

export default kidSchema;
